import { render, staticRenderFns } from "./AssemblyComp.vue?vue&type=template&id=1824b549"
import script from "./AssemblyComp.vue?vue&type=script&lang=js"
export * from "./AssemblyComp.vue?vue&type=script&lang=js"
import style0 from "./AssemblyComp.vue?vue&type=style&index=0&id=1824b549&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports